export const CONFIG = {
  APP_TITLE: 'CIMB FlexiPay',
  PAGE_TITLE: 'Application',
};
